// What you can actually DO here, told while the town downloads.
//
// These replaced journal quotes on the veil: a first-time visitor does
// not yet care what he wrote, they need a reason to stay, and "you can
// leave him something and he will remember you" is that reason. Shipped
// in the bundle so the first one is on screen the instant the veil is,
// no fetch, no failure mode.
//
// Add to this list as features land. Rules: every line must be TRUE
// today (nothing aspirational), plain speech, no jargon, and short
// enough to read twice before it rotates.

export const LOADING_TIPS = [
  "Leave him something, a message or a picture. He'll read it in his own time and remember you next time you visit",
  "The more of yours he keeps, the more Pino trusts you and lets you into his world",
  "His diary has what he did today and what he made of it, in his own words",
  "Pino's brain page shows what he cares about and what he has decided lately. It changes as he lives",
  "Everything Pino does is his own decision. Nobody scripts his days, not even us",
]
